import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as PrintIcon } from '@assets/icons/pdf/print.svg';

import AddFabricInline from '@components/materials/AddFabricInline';
import ModalContainer from '@components/modals/ModalContainer';
import NitexImageCropper from '@components/NitexImageCropper';
import { toastError, toastSuccess, toastWarning } from '@components/Toast';

import AddLocationModal from '@features/design/components/AddLocationModal';
import AllSampleAccordion from '@features/design/components/AllSampleAccordion';
import DesignBasicInfoSection from '@features/design/components/DesignBasicInfoSection';
import {
	createBrandResponseOnSelectBuyerTP,
	createCountryResponseOnSelectSampleId,
	createInitialSampleData,
	createSampleTypeOnSelectSampleId,
	DESIGN_INFO_INITIAL_STATE,
	TECHPACK_CHECKLIST_STATE,
	USER_TYPES
} from '@features/design/utils/designUtils';

import { fetchProductInfo } from '@store/actions/DesignToolAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getBrands, getFabricTypes, getMarkets } from '@store/design/action';
import { getAllBrands, getAllFabricTypes, getAllMarkets, useDesignViewModal } from '@store/reducers';
import { setUpdatedArchivedProductId } from '@store/searchOptions/actions';

import { getProductInfoByProductId } from '@services/commonService';
import { fetchAllProductTags, saveProductRemarks } from '@services/collectionService';
import { findAllSupplier } from '@services/costingService';
import {
	deleteProductImage,
	fetchBodyFabric,
	fetchDesignLooks,
	fetchProductCategories,
	fetchUsersListByRole,
	getProductSampleLocations,
	getProductSamples,
	getSampleCountryList,
	replaceBodyFabric,
	submitSampleUpdate,
	uloadProductImage,
	updateBodyFabric,
	updateCroppedImageOnSave,
	updateDesignBasicInfo,
	updateSampelInventory
} from '@services/designInfoUpdateService';

import ApiClient from '@lib/apiClient';

import { isValidFile, printApiError } from '@utils/Util';

import { VALID_FILE_SIZE } from '@/constants/constant';

import IssueAndStatusSection from '@/features/design/components/IssueAndStatusSection';
import TechpackChecklist from '@/features/design/components/TechpackChecklist';
import CreateAndSolveIssueModal from '@/features/design/components/CreateAndSolveIssuePanel';
import AddTaskModal from '@/components/AddTaskModal';
import {
	useGetIssueListQuery,
	useGetProductFutureSampleQuery,
	useUpdateTechpackChecklistMutation
} from '@/features/design/api/designDetailsApi';
import { updateDesignViewModalInfo } from '@/store/actions/DesignViewModalAction';
import PrintAndDownload from '@/features/design/components/PrintAndDownload';
// import CreateNewTask from '@/features/Scan/components/CreateNewTask';

const DesignUpdate = ({
	productId,
	onSetNitexTab,
	activeId,
	isNitexTechpack,
	onChangeActiveTab,
	requestFrom,
	setProductDocumentList,
	onCloseALl,
	fetchDesignPublishStatus,
	setOpenCommentPanel,
	defaultIsDesignEdit = false,
	onBasicInfoUpdateSuccess
}) => {
	// Design Basic info Section Sates
	const [isDesignEdit, setIsDesignEdit] = useState(defaultIsDesignEdit);
	const [selectedDesignInfo, setSelectedDesignInfo] = useState(DESIGN_INFO_INITIAL_STATE);
	const [categories, setCategories] = useState([]);
	const [fabricType, setFabricType] = useState([]);
	const [bodyFabric, setBodyFabric] = useState([]);
	const [designers, setDesigners] = useState([]);
	const [graphicDesigners, setGraphicDesigners] = useState([]);
	const [threeDDesigner, setThreeDDesigner] = useState('');
	const [tpCompleatedBy, setTpCompleatedBy] = useState([]);
	const [looks, setLooks] = useState([]);
	const [tags, setTags] = useState([]);
	const [selectedImage, setSelectedImage] = useState(null);
	const [designDetails, setDesignDetails] = useState({});
	const [isCropImage, setIsCropImage] = useState(false);
	const [mainImageUrl, setMainImageUrl] = useState('');
	const [croppedBodyData, setCroppedBodyData] = useState({
		id: '',
		base64Str: '',
		docMimeType: 'image/jpeg',
		extension: 'jpeg'
	});
	const markets = useSelector(getAllMarkets);
	const [marketList, setMarketList] = useState([]);
	const allFabricTypes = useSelector(getAllFabricTypes) || [];
	const brandsList = useSelector(getAllBrands) || [];
	const [countryList, setCountryList] = useState([]);
	const [brands, setBrands] = useState([]);
	const dispatch = useDispatch();
	const [mainFabric, setMainFabric] = useState(null);
	// Sample Accordion States
	const [locationsList, setLocationsList] = useState([]);
	const [showAddLocationModal, setShowAddLocationModal] = useState(false);
	const [allSampleList, setAllSampleList] = useState([]);
	const [selectedRowId, setSelectedRowId] = useState(null);
	const [suppliers, setSuppliers] = useState([]);
	const [sampleErrors, setSampleErrors] = useState([]);
	const [selectdSampleToEdit, setSelectdSampleToEdit] = useState(null);
	const [, setTouchedRows] = useState([]); // To check if user put sample Inventroy value.
	const [isOpenAddNewFabricModal, setIsOpenAddNewFabricModal] = useState(false);
	const [parentId, setParentId] = useState(null);
	const [activeRow, setActiveRow] = useState(null);
	const [newlyAddedFabricData, setNewlyAddedFabricData] = useState(null);
	const [originalSampleResponse, setOriginalSampleResponse] = useState([]); // To Reset sample list when click "Cancel"
	const [originalDesignDetailsResponse, setOriginalDesignDetailsResponse] = useState({});
	const { isUpdateSampleId, isFocusOnModalClose } = useSelector(
		(store) => store.collectionSearchOptionStore
	);
	const [remarks, setRemarks] = useState('');
	const [currentPagePath, setCurrentPagePath] = useState('');
	const { isSoldFolder } = useDesignViewModal();
	const [errors, setErrors] = useState({});
	const [isShowIssueModal, setIsShowIssueModal] = useState(false);
	const [isShowUpdateTaskModal, setIsShowUpdateTaskModal] = useState(false);
	const [techpackChecklistState, setTechpackChecklistState] = useState(TECHPACK_CHECKLIST_STATE);
	const [selectedIssueToEdit, setSelectedIssueToEdit] = useState(null);
	const { isOpenIssueModal } = useSelector((store) => store?.designViewModalStore);
	const [activeIssueIndex, setActiveIssueIndex] = useState(0);
	const [isShowPrintDropdown, setIsShowPrintDropdown] = useState(false);

	const { data: issueList = [] } = useGetIssueListQuery({
		productId
	});
	const { data: futureProductSample, refetch: refetchFutureSample } = useGetProductFutureSampleQuery({
		productId: productId
	});

	// const [isShowCreateNewTaskModal, setIsShowCreateNewTaskModal] = useState(false);
	// const [taskInputValueFromTaskModal, setTaskInputValueFromTaskModal] = useState('');

	const [updateTechpackChecklist] = useUpdateTechpackChecklistMutation();

	const refetchArchiveList = () => {
		if (currentPagePath === '/collections/list') {
			dispatch(setUpdatedArchivedProductId(null));
		}
	};

	useEffect(() => {
		setCurrentPagePath(window.location.pathname);
	}, [window.location.pathname]);

	useEffect(() => {
		refetchArchiveList();
	}, [currentPagePath]);

	useEffect(() => {
		if (designDetails?.collectionRemarks) {
			setRemarks(designDetails?.collectionRemarks);
		}
	}, [designDetails?.collectionRemarks]);

	useEffect(() => {
		if (isUpdateSampleId) setIsDesignEdit(true);
	}, [isUpdateSampleId]);

	const onParseInputName = async (type, value) => {
		setIsOpenAddNewFabricModal(true);
		try {
			const { data } = await ApiClient.GET('setParseInputName', `?name=${encodeURIComponent(value)}`);
			setNewlyAddedFabricData({
				fabricType: data.fabricType,
				fabricTypeWithConstruction:
					data.fabricType && data.construction ? `${data.fabricType}-${data.construction}` : '',
				compositionDetails: data.compositionDetails,
				weight: data.weight,
				constructionId: data.constructionId,
				compositionPartList: data.compositionPartList,
				weightType:
					data.fabricType === 'SWEATER' ? 'GAUGE' : data.fabricType === 'DENIM' ? 'OZ' : 'GSM',
				fabricCompositionPartIdList: data.fabricCompositionPartIdList,
				description: data.description
			});
		} catch ({ response }) {
			if (response.data.message) {
				toastError(response.data.message);
			} else {
				toastError('Something went wrong! Please try again.');
			}
		}
	};

	useEffect(() => {
		if (markets?.length) {
			const marketItes = markets.map((item) => ({
				...item,
				value: item?.name
			}));
			setMarketList(marketItes);
		}
	}, [markets?.length]);

	useEffect(() => {
		if (allFabricTypes) {
			const fabricTypes = allFabricTypes.map((fabric) => ({
				id: fabric?.code,
				name: fabric?.value,
				...fabric
			}));
			setFabricType(fabricTypes);
		}
	}, [allFabricTypes.length]);

	const formatProductInfo = async () => {
		try {
			if (productId) {
				let params = `${productId}?checkBuyerSelectionStatus=true`;
				const productInfo = await getProductInfoByProductId(params);
				setParentId(productInfo?.id);
				setDesignDetails({
					...productInfo,
					productGroupId: productInfo?.productGroupResponse?.id
				});

				const designInfo = {
					designNum: productInfo?.systemReferenceNumber,
					buyerDesignNum: productInfo?.referenceNumber,
					selectedMarket: productInfo?.productGroupResponse,
					selectedCategory: productInfo?.subCategoryResponse,
					selectedFabricType: {
						name: productInfo?.mainFabricType,
						id: productInfo?.mainFabricType
					},
					selectedBodyFabric:
						productInfo?.mainFabricResponses?.length > 0
							? {
									name: productInfo?.mainFabricResponses[0]?.name,
									id: productInfo?.mainFabricResponses[0]?.id
								}
							: null,
					selectedBrand: {
						name: productInfo?.brandName,
						id: productInfo?.brandId
					},
					selectedNitexDesign: {
						id: productInfo?.isNitexProduct ? true : false,
						value: productInfo?.isNitexProduct ? 'YES' : 'NO',
						name: productInfo?.isNitexProduct ? 'YES' : 'NO'
					},
					selectedDesigner: {
						id: productInfo?.designer?.id,
						name: productInfo?.designer?.name
					},
					selectedTpCompleatedBy: {
						id: productInfo?.tpCompletedBy?.id,
						name: productInfo?.tpCompletedBy?.name
					},
					selectedLook: {
						id: productInfo?.designLook,
						name: productInfo?.designLook
					},
					selectedTags: [],
					selectedCustomizeBy: {
						id: productInfo?.customizedBy?.id,
						name: productInfo?.customizedBy?.name
					},

					graphicDesigner: {
						...productInfo?.graphicDesigner,
						value: productInfo?.graphicDesigner?.name
					},
					selectedThreeDDesigner: {
						id: productInfo?.threeDDesigner?.id,
						name: productInfo?.threeDDesigner?.name
					}
				};
				setOriginalDesignDetailsResponse(designInfo);
				// Populate the satate with initial design data
				setSelectedDesignInfo(designInfo);
				setSelectedImage(productInfo?.designDocuments ? productInfo?.designDocuments[0] : null);
				setMainFabric(
					productInfo?.fabrics && productInfo?.fabrics.length > 0 ? productInfo?.fabrics[0] : null
				);
				setTechpackChecklistState({
					styleBlock: null,
					stylingAndOther: productInfo?.stylingDetails,
					stitching: productInfo?.stitchingDetails,
					print: productInfo?.printCategoryList?.map((printItem) => ({
						...printItem,
						label: printItem?.name,
						value: printItem?.name
					})),

					wash: productInfo?.washCategoryList?.map((wash) => ({
						...wash,
						label: wash?.name,
						value: wash?.name
					})),
					embroidery: productInfo?.embroideryCategoryList?.map((embroideryItem) => ({
						...embroideryItem,
						label: embroideryItem?.name,
						value: embroideryItem?.name
					})),
					fabricDyeColor: productInfo?.fabricDyeColorResponse
						? [productInfo?.fabricDyeColorResponse]
						: [],
					trimsDyeColor: productInfo?.trimsDyeColorResponse
						? [productInfo?.trimsDyeColorResponse]
						: [],
					bodyWidth:
						productInfo?.bodyWidthList?.length > 0
							? {
									...productInfo?.bodyWidthList[0],
									id: productInfo?.bodyWidthList[0]?.constant,
									value: productInfo?.bodyWidthList[0]?.name
								}
							: {},
					bodyHeight:
						productInfo?.bodyLengthList?.length > 0
							? {
									...productInfo?.bodyLengthList[0],
									id: productInfo?.bodyLengthList[0]?.constant,
									value: productInfo?.bodyLengthList[0]?.name
								}
							: {},
					sleeves:
						productInfo?.sleevesList?.length > 0
							? {
									...productInfo?.sleevesList[0],
									id: productInfo?.sleevesList[0]?.constant,
									value: productInfo?.sleevesList[0]?.name
								}
							: {},
					fittingType: {
						...productInfo?.blockFittingInfoResponse,
						value: productInfo?.blockFittingInfoResponse?.text
					},
					action: {
						...productInfo?.measurementChartInfoType,
						id: productInfo?.measurementChartInfoType?.constant,
						value: productInfo?.measurementChartInfoType?.name
					}
				});
			}
		} catch (error) {
			printApiError(error);
		}
	};

	const getCategories = async () => {
		try {
			const response = await fetchProductCategories();
			setCategories(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getBodyFabrics = async (searchKey, fabricType) => {
		try {
			const { data } = await fetchBodyFabric(searchKey, fabricType);
			const response = data?.data?.map((item) => ({
				...item,
				value: item?.name
			}));
			setBodyFabric(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getDesignLooks = async () => {
		try {
			const response = await fetchDesignLooks();
			setLooks(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const getGarmentsTechUsers = async () => {
		try {
			const params = `?userTypes=${USER_TYPES.GARMENTS_TECH}&${USER_TYPES.FASHION_DESIGNER}&${USER_TYPES.GRAPHICS_DESIGNER}&${USER_TYPES.threeDDesigner}&page=0&size=1000`;
			const response = await fetchUsersListByRole(params);
			const designers = response?.filter(
				(item) =>
					item?.primaryUserType === USER_TYPES.FASHION_DESIGNER ||
					item?.primaryUserType === USER_TYPES.GRAPHICS_DESIGNER
			);
			// const graphicDesignersList = response?.filter(
			// 	(item) => item?.primaryUserType === USER_TYPES.GRAPHICS_DESIGNER
			// );
			const threeDDesigner = response?.filter(
				(item) => item.primaryUserType === USER_TYPES.THREE_D_DESIGNER
			);
			setTpCompleatedBy(response);
			setDesigners(designers);
			setGraphicDesigners(designers);
			setThreeDDesigner(threeDDesigner);
		} catch (error) {
			printApiError(error);
		}
	};

	const getAllTags = async (searchKey) => {
		try {
			let params = '?type=PRODUCT_COLLECTION_TAGS&entityActivityType=PRODUCT_TAG_UPDATE';
			if (searchKey) {
				params += `&search=${encodeURIComponent(searchKey)}`;
			}
			const data = await fetchAllProductTags(params, null);

			setTags(data);
			dispatch(closeLoader());
		} catch (error) {
			printApiError(error);
		}
	};

	useEffect(() => {
		getCategories();
		dispatch(getMarkets());
		dispatch(getFabricTypes());
		dispatch(getBrands(`?page=0&size=1000`));
		getDesignLooks();
		getGarmentsTechUsers();
		fetchCountryList();
		fetchSuppliers();
		fetchSampleLocations();
	}, [productId]);

	useEffect(() => {
		formatProductInfo();
		if (designDetails && parentId) {
			fetchAllSample();
		}
	}, [productId, parentId]);

	useEffect(() => {
		getBodyFabrics('', selectedDesignInfo?.selectedFabricType?.id);
	}, [selectedDesignInfo?.selectedBodyFabric?.id]);

	useEffect(() => {
		const allBrands = brandsList?.map((brand) => ({
			...brand,
			value: brand?.name
		}));
		setBrands(allBrands);
	}, [brandsList.length]);

	const handleDesignInfoInputChange = (e) => {
		const { value, name } = e.target;
		setSelectedDesignInfo((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const updateCountryResponseOnSelectNitexDesign = (isNitexDesign) => {
		const updatedSamples = allSampleList.map((item) => {
			if (isNitexDesign && item?.rowId === 1 && item?.sampleId) {
				return {
					...item,
					countryResponse: null,
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: null
				};
			} else if (isNitexDesign && item?.rowId === 2 && item?.sampleId) {
				return {
					...item,
					countryResponse: null,
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: null
				};
			} else if (!isNitexDesign && item?.sampleId) {
				return {
					...item,
					countryResponse: null,
					sampleType: createSampleTypeOnSelectSampleId(isNitexDesign),
					brandResponse: createBrandResponseOnSelectBuyerTP(
						isNitexDesign,
						selectedDesignInfo?.selectedBrand
					)
				};
			} else {
				return {
					...item
				};
			}
		});

		setAllSampleList(updatedSamples);
	};

	const handleSelectDesignInfoOption = (option, dropdownName) => {
		if (dropdownName === 'selectedFabricType') {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option },
				selectedBodyFabric: null
			}));

			getBodyFabrics('', option?.id);
		} else if (dropdownName === 'selectedNitexDesign') {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option }
			}));
			updateCountryResponseOnSelectNitexDesign(option?.id);
		} else {
			setSelectedDesignInfo((prev) => ({
				...prev,
				[dropdownName]: { ...option }
			}));
		}
	};

	const handleUpdateBodyFabric = async (selectedBodyFabricValue) => {
		try {
			setSelectedDesignInfo((prev) => ({
				...prev,
				selectedBodyFabric: {
					name: selectedBodyFabricValue?.name,
					id: selectedBodyFabricValue?.id
				}
			}));

			if (mainFabric?.id) {
				await replaceBodyFabric(designDetails?.id, selectedBodyFabricValue?.id, mainFabric?.id);
			} else {
				await updateBodyFabric(designDetails?.id, selectedBodyFabricValue?.id);
			}
			const designRequestBody = createDesignRequestBody();
			await updateDesignBasicInfo(designRequestBody, productId);

			dispatch(fetchProductInfo(productId));
		} catch (error) {
			printApiError(error);
		}
	};

	const updateTagList = (payload) => {
		const tagResponse = payload[0]?.tagResponseList;
		setDesignDetails((prev) => ({
			...prev,
			tagResponseList: tagResponse
		}));
	};

	// Upload Design Image and Cropp Image Functionality

	const handleUploadProductImage = async (body) => {
		try {
			dispatch(openLoader());
			const { data } = await uloadProductImage(body, designDetails?.id);
			if (data) {
				if (selectedImage?.id) {
					await deleteProductImage(designDetails?.id, selectedImage.id);
				}
				setSelectedImage({ ...data?.payload });
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const handleDesignUpload = (e, docType = 'PRODUCT_DESIGN') => {
		let file = e.target.files[0];
		if (file) {
			if (isValidFile(file, file?.type, VALID_FILE_SIZE)) {
				let data = {
					name: file?.name,
					docMimeType: file?.type,
					documentType: docType,
					base64Str: ''
				};
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => {
					data.base64Str = reader.result;
					handleUploadProductImage(data);
				};
				reader.onerror = function (error) {
					toastError(error);
				};
			} else {
				toastWarning('Please upload file less than 12mb');
			}
		}
	};

	const handleCropeImage = (e, id, img) => {
		setIsCropImage(true);
		setCroppedBodyData({ ...croppedBodyData, id: id });
		setMainImageUrl(img);
	};

	const handleCloseCroperModal = () => {
		setIsCropImage(false);
		setMainImageUrl('');
	};

	const handleSaveCropedImage = async (base64str) => {
		try {
			dispatch(openLoader());
			if (base64str) {
				const { data } = await updateCroppedImageOnSave(
					{ ...croppedBodyData, base64Str: base64str },
					productId
				);
				setSelectedImage(data);
				dispatch(closeLoader());
			} else {
				dispatch(closeLoader());
				toastError('Crop was not successful');
			}
			handleCloseCroperModal();
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	// All Samples Accordion
	const handleSelectSampleLocation = (value, rowId) => {
		setSelectdSampleToEdit(value);
		setShowAddLocationModal(true);
		setActiveRow(rowId);
	};

	// update changed Sample Owner
	const handleChangeSampleOwner = (value, rowId) => {
		const updatedSamplerOWners = [...allSampleList]?.map((item) => {
			if (parseInt(item?.rowId) === parseInt(rowId)) {
				return {
					...item,
					owner: value
				};
			}
			return {
				...item
			};
		});
		setAllSampleList(updatedSamplerOWners);
	};

	const handleChangeSampleInputField = (e, rowId) => {
		const { name, value } = e.target;
		const updatedSampleList = allSampleList.map((item) => {
			if (item?.rowId === rowId) {
				if (name === 'sampleId') {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[name]: value,
						qcApprovalDate: item?.qcApprovalDate
							? item?.qcApprovalDate
							: new Date().toISOString().split('T')[0],
						countryResponse: item?.countryResponse?.id
							? item?.countryResponse
							: createCountryResponseOnSelectSampleId(
									rowId,
									selectedDesignInfo?.selectedNitexDesign?.id
								),
						sampleType: item?.sampleType
							? item?.sampleType
							: createSampleTypeOnSelectSampleId(selectedDesignInfo?.selectedNitexDesign?.id),
						brandResponse: item?.brandResponse
							? item?.brandResponse
							: createBrandResponseOnSelectBuyerTP(
									selectedDesignInfo?.selectedNitexDesign?.id,
									selectedDesignInfo?.selectedBrand
								),
						sampleStatus: 'AVAILABLE'
					};
				} else {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[name]: value
					};
				}
			}
			return item;
		});

		setAllSampleList(updatedSampleList);
	};

	const handleSelectSampleOptions = (value, optionName, rowId, isObject = false) => {
		const updatedSampleList = allSampleList.map((item) => {
			if (item?.rowId === rowId) {
				if (optionName === 'sampleType') {
					setTouchedRows((prev) => [...prev, rowId]);
					if (value === 'BUYER_TP_DEVELOPMENT' && !item?.brandResponse?.id) {
						return {
							...item,
							[optionName]: isObject ? { ...value } : value,
							brandResponse: selectedDesignInfo?.selectedBrand,
							supplierResponse: {}
						};
					} else {
						return {
							...item,
							[optionName]: isObject ? { ...value } : value,
							brandResponse: {},
							supplierResponse: {}
						};
					}
				} else {
					setTouchedRows((prev) => [...prev, rowId]);
					return {
						...item,
						[optionName]: isObject ? { ...value } : value
					};
				}
			}
			return item;
		});
		setAllSampleList(updatedSampleList);
	};

	const handleCloseLocationModal = () => {
		setShowAddLocationModal(false);
	};

	const fetchAllSample = async (futureSamples = futureProductSample) => {
		try {
			const response = await getProductSamples(productId, 'DESIGN_INFO_VIEW');

			const samplesList = [];
			let rowIdCounter = 1;

			response.forEach((item) => {
				item?.itemList.forEach((list) => {
					samplesList.push({
						...list,
						productResponse: item?.productResponse,
						rowId: rowIdCounter++,
						owner: {
							userResponse: { ...list?.recipient, value: list?.recipient?.nickName }
						}
					});
				});
			});

			const createEmptyRows = [];
			if (futureSamples && futureSamples.length > 0) {
				futureSamples.forEach((item) => {
					createEmptyRows.push(
						createInitialSampleData(item?.id, productId, {
							...item,

							userResponse: {
								...item?.userResponse,
								value: item?.userResponse?.nickName,
								futureSampleId: item?.id
							}
						})
					);
				});

				setOriginalSampleResponse([...samplesList, ...createEmptyRows]);
				setAllSampleList([...samplesList, ...createEmptyRows]);
			} else {
				setOriginalSampleResponse(samplesList);
				setAllSampleList(samplesList);
			}
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchSampleLocations = async (searchKey = '') => {
		try {
			const params = `?search=${encodeURIComponent(searchKey)}&page=0&size=20`;
			const response = await getProductSampleLocations(params);

			const locationsArr = response?.map((item) => ({
				...item,
				secondLine: [
					item?.countryResponse?.code,
					item?.buildingTagResponse?.text,
					item?.floorTagResponse?.text,
					item?.roomOrAreaTagResponse?.text,
					item?.otherDetails
				]
					.filter(Boolean)
					.join(', ')
			}));
			setLocationsList(locationsArr);
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchCountryList = async () => {
		try {
			const response = await getSampleCountryList();
			setCountryList(response);
		} catch (error) {
			printApiError(error);
		}
	};

	const fetchSuppliers = async (searchKey = '') => {
		try {
			const params = `?page=0&size=20&name=${searchKey}&materialType=GARMENT&sort=id,desc`;
			const { data = [] } = await findAllSupplier(params);

			const suppliersList = data?.map((item) => ({
				...item,
				value: item?.name
			}));

			setSuppliers(suppliersList);
		} catch (error) {
			printApiError(error);
		}
	};

	const handleAddNewRow = () => {
		setAllSampleList((prev) => {
			const lastRowId = prev && prev.length ? prev[prev.length - 1]?.rowId : null;
			const newRowId = lastRowId ? `${lastRowId}_CUSTOM_ROW` + 1 : `${lastRowId}_NEW_ROW`;
			return [...prev, createInitialSampleData(newRowId, productId)];
		}); // row id = last rowId + 1, or 1 when list is empty
	};

	const createDesignRequestBody = () => {
		// Design update request body
		const designInfoRequestBody = {
			id: designDetails.id,
			name: selectedDesignInfo?.name,
			referenceNumber: selectedDesignInfo?.buyerDesignNum,
			systemReferenceNumber: selectedDesignInfo?.designNum,
			productCategoryId: selectedDesignInfo?.selectedCategory?.ctgId,
			productSubCategoryId: selectedDesignInfo?.selectedCategory?.id,
			productGroupId: selectedDesignInfo?.selectedMarket?.id,
			isNitexProduct: selectedDesignInfo?.selectedNitexDesign?.id,
			brandId: selectedDesignInfo?.selectedBrand?.id,
			fabricType: selectedDesignInfo?.selectedFabricType?.id,
			fabricName: selectedDesignInfo?.selectedBodyFabric?.name || null,
			designLook: selectedDesignInfo?.selectedLook?.id,
			tpCompletedById: selectedDesignInfo?.selectedTpCompleatedBy?.id,
			designerId: selectedDesignInfo?.selectedDesigner?.id,
			customizedById: selectedDesignInfo?.selectedCustomizeBy?.id,
			graphicsDesignerId: selectedDesignInfo?.graphicDesigner?.id,
			threeDDesignerId: selectedDesignInfo?.selectedThreeDDesigner?.id
		};
		return designInfoRequestBody;
	};

	const handleWrongEntry = async (sampleId, isWrongEntry) => {
		try {
			dispatch(openLoader());
			await updateSampelInventory(sampleId, isWrongEntry);
			await fetchAllSample();
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const createTechpackChecklistRequestBody = () => {
		const techpackChecklistStatePrintIdList = techpackChecklistState?.print || [];
		const techpackChecklistStateWashIdList = techpackChecklistState?.wash || [];
		const techpackChecklistStateEmbroideryIdList = techpackChecklistState?.embroidery || [];
		// Techpack checklist request body
		const techpackChecklistRequestBody = {
			stitchingDetails: techpackChecklistState?.stitching,
			stylingDetails: techpackChecklistState?.stylingAndOther,
			// existingBodyFabricId: 0,
			// newBodyFabricId: 0,

			printCategoryIdList: techpackChecklistStatePrintIdList?.map((printItem) => printItem?.id),
			washCategoryIdList: techpackChecklistStateWashIdList?.map((washItem) => washItem?.id),
			embroideryCategoryIdList: techpackChecklistStateEmbroideryIdList?.map(
				(embroideryItem) => embroideryItem?.id
			),
			fabricDyeColorId: techpackChecklistState?.fabricDyeColor[0]?.id,
			trimsDyeColorId: techpackChecklistState?.trimsDyeColor[0]?.id,
			bodyLengthList: techpackChecklistState?.bodyHeight?.id
				? [techpackChecklistState?.bodyHeight?.id]
				: null,
			bodyWidthList: techpackChecklistState?.bodyWidth?.id
				? [techpackChecklistState?.bodyWidth?.id]
				: null,
			sleevesList: techpackChecklistState?.sleeves?.id ? [techpackChecklistState?.sleeves?.id] : null,
			measurementChartInfoType: techpackChecklistState?.action?.id,
			blockFittingInfoRequest: techpackChecklistState?.fittingType?.value
				? {
						text: techpackChecklistState?.fittingType?.value,
						id: techpackChecklistState?.fittingType?.id
					}
				: null
		};
		return techpackChecklistRequestBody;
	};

	const createSampleRequestBody = () => {
		// Sample inventory request body
		const sampleInventoryRequestBody = allSampleList.map((item) => {
			//TODO:
			const sample = {
				id: item?.id,
				productId: item?.productId,
				sampleId: item?.sampleId,
				countryId: item?.countryResponse?.id,
				qcApprovalDate: item?.qcApprovalDate,
				color: item?.color,
				size: item?.size,
				sampleType: item?.sampleType,
				sampleStatus: item?.sampleStatus ? item?.sampleStatus : item?.sampleId ? 'AVAILABLE' : null,
				remarks: item?.remarks,
				brandId: item?.brandResponse?.id,
				supplierId: item?.supplierResponse?.id,
				sampleInventoryLocationId: item?.sampleInventoryLocationResponse?.id,
				wrongEntrySampleId: item?.wrongEntrySampleId,
				isWrongEntry: item?.isWrongEntry,
				sampleItemDetailsRecipientMapId: item?.owner?.userResponse?.futureSampleId || null,
				sampleItemDetailsRecipientId: item?.owner?.userResponse?.id || null
			};

			const filteredSample = Object.fromEntries(
				Object.entries(sample).filter(([, value]) => value != null)
			);

			return filteredSample;
		});

		return sampleInventoryRequestBody.filter(
			(item) => item?.sampleId && parseInt(parentId) === parseInt(item?.productId)
		);
	};

	const validateCheckList = () => {
		const newError = {};

		if (designDetails?.printCategoryList !== undefined && techpackChecklistState?.print?.length === 0) {
			newError.print = 'Print can not be empty';
			toastError('Print can not be empty');
		}
		if (designDetails?.washCategoryList !== undefined && techpackChecklistState?.wash?.length === 0) {
			newError.wash = 'Wash can not be empty';
			toastError('Wash can not be empty');
		}
		if (
			designDetails?.embroideryCategoryList !== undefined &&
			techpackChecklistState?.embroidery?.length === 0
		) {
			newError.embroidery = 'Embroidery can not be empty';
			toastError('Embroidery can not be empty');
		}
		return newError;
	};

	const isValid = () => {
		let errObj = {};
		if (!selectedDesignInfo?.selectedMarket?.name) {
			errObj['marketError'] = 'Please select market';
		}
		if (!selectedDesignInfo?.selectedCategory?.name) {
			errObj['categoryError'] = 'Please select category';
		}
		setErrors(errObj);
		return Object.keys(errObj).length === 0;
	};

	// Submit Updated design
	const handleSubmitInfo = async () => {
		if (!isValid()) {
			return;
		}
		const checklistError = validateCheckList();
		if (Object.keys(checklistError).length > 0) {
			return;
		}

		const sampleBody = createSampleRequestBody();
		refetchArchiveList();

		try {
			dispatch(openLoader());
			const designRequestBody = createDesignRequestBody();
			const { data: designInfoResponse } = await updateDesignBasicInfo(designRequestBody, productId);
			const sampleResponse = await submitSampleUpdate(sampleBody);
			// refetch future samples and capture the returned data so we can use it immediately
			let refetchedFuture = null;
			try {
				const refetchResult = await refetchFutureSample();
				refetchedFuture = refetchResult?.data ?? refetchResult;
			} catch (e) {
				// log refetch error and continue without refetched future samples
				printApiError(e);
				refetchedFuture = null;
			}

			await saveProductRemarks(productId, `?remarks=${encodeURIComponent(remarks)}`);

			await updateTechpackChecklist({
				body: createTechpackChecklistRequestBody(),
				productId: productId
			})
				.unwrap()
				.then(() => {
					formatProductInfo();
				})
				.catch((error) => {
					toastError(error?.data?.message || 'Something went wrong');
				});

			if (designInfoResponse?.success && sampleResponse?.success) {
				const data = await getProductInfoByProductId(productId);
				if (onBasicInfoUpdateSuccess) {
					onBasicInfoUpdateSuccess(productId, data);
				}
				await fetchAllSample(refetchedFuture);
				fetchDesignPublishStatus && (await fetchDesignPublishStatus());

				setIsDesignEdit(false);
				toastSuccess('Update Successful!');
				setSampleErrors([]);
				setTouchedRows([]);
				if (isFocusOnModalClose) {
					onCloseALl();
				}
				refetchArchiveList();
			}
		} catch (error) {
			printApiError(error);
		} finally {
			dispatch(closeLoader());
		}
	};

	const handleReset = () => {
		setAllSampleList(originalSampleResponse);
		setSelectedDesignInfo(originalDesignDetailsResponse);
		setIsDesignEdit(false);
		setSampleErrors([]);
		setTechpackChecklistState(TECHPACK_CHECKLIST_STATE);
	};

	const renderBottomPart = () => {
		const allImageNotDocuments =
			requestFrom === 'SET_PRODUCT_VIEW' ? setProductDocumentList : designDetails?.allNotImageDocuments;
		return (
			<div className="d-flex justify-content-between align-items-center">
				<div className="d-flex align-items-center">
					<div className="uploaded-teckpacks">
						{designDetails?.extraFlag?.isArtBoardCreated && (
							<span
								className={`cursor-pointer chip-square ${
									isNitexTechpack === true ? 'active' : ''
								}`}
								onClick={onSetNitexTab}
							>
								Nitex techpack
							</span>
						)}

						{allImageNotDocuments?.map((item) => (
							<span
								className={`cursor-pointer chip-square ${
									item.id === activeId ? 'active' : ''
								}`}
								key={item.id}
								onClick={() => onChangeActiveTab(item)}
							>
								{item?.name?.length <= 25 ? item?.name : item?.name}
							</span>
						))}
					</div>
				</div>
			</div>
		);
	};

	return (
		<React.Fragment>
			<div className="style-header d-flex justify-content-between align-items-center mb-3 position-relative">
				<div>
					<p className="regular-16 weight-700 gray_dark_01">STYLE DETAILS</p>
				</div>
				<div className="d-flex align-items-center">
					<div
						className="print-icon mr-4 cursor-pointer"
						onClick={() => setIsShowPrintDropdown((prev) => !prev)}
					>
						<PrintIcon />
					</div>
					{isDesignEdit && (
						<div className="style-buttons">
							<button
								className="button size32 gray-outline bg-white"
								onClick={() => {
									handleReset();
								}}
							>
								Cancel
							</button>
							<button
								className="button size32 ml-12"
								onClick={() => {
									handleSubmitInfo();
								}}
							>
								Update
							</button>
						</div>
					)}
					{!isDesignEdit && (
						<div className="style-buttons">
							<button
								className="button size32"
								onClick={() => setIsDesignEdit(true)}
								disabled={isSoldFolder}
							>
								Edit basic info
							</button>
						</div>
					)}
				</div>
				{isShowPrintDropdown && (
					<PrintAndDownload productId={productId} onClose={() => setIsShowPrintDropdown()} />
				)}{' '}
			</div>
			<DesignBasicInfoSection
				productId={productId}
				isDesignEdit={isDesignEdit}
				onDesignUpload={handleDesignUpload}
				onCropeImage={handleCropeImage}
				selectedImage={selectedImage}
				categories={categories}
				fabricType={fabricType}
				bodyFabric={bodyFabric}
				designers={designers}
				tpCompleatedBy={tpCompleatedBy}
				looks={looks}
				tags={tags}
				onDesignInputChange={handleDesignInfoInputChange}
				onSelectOption={handleSelectDesignInfoOption}
				onGetBodyFabrics={getBodyFabrics}
				onUpdateTagList={updateTagList}
				onGetAllTags={getAllTags}
				onUpdateBodyFabric={handleUpdateBodyFabric}
				selectedDesignInfo={selectedDesignInfo}
				marketList={marketList}
				brands={brands}
				designDetails={designDetails}
				onParseInputName={onParseInputName}
				remarks={remarks}
				setRemarks={setRemarks}
				errors={errors}
				graphicDesigners={graphicDesigners}
				threeDDesigner={threeDDesigner}
			/>

			<IssueAndStatusSection
				onShowIssueModal={() => {
					setIsShowIssueModal(true);
					setSelectedIssueToEdit(null);
					setOpenCommentPanel(false);
				}}
				onShowUpdateTask={() => setIsShowUpdateTaskModal(true)}
				setSelectedIssueToEdit={setSelectedIssueToEdit}
				productId={productId}
				designDetails={designDetails}
				activeIssueIndex={activeIssueIndex}
				setActiveIssueIndex={setActiveIssueIndex}
				issueList={issueList}
			/>

			<TechpackChecklist
				techpackChecklistState={techpackChecklistState}
				isDesignEdit={isDesignEdit}
				setTechpackChecklistState={setTechpackChecklistState}
				productId={productId}
				onGetBodyFabrics={getBodyFabrics}
				onUpdateBodyFabric={handleUpdateBodyFabric}
				onParseInputName={onParseInputName}
				bodyFabricList={bodyFabric}
				selectedBodyFabric={selectedDesignInfo?.selectedBodyFabric}
				designDetails={designDetails}
				reloadTechpack={formatProductInfo}
			/>

			<AllSampleAccordion
				isDesignEdit={isDesignEdit}
				setIsDesignEdit={setIsDesignEdit}
				onChangeSampleInputField={handleChangeSampleInputField}
				onSelectOptions={handleSelectSampleOptions}
				onSelectSampleLocation={handleSelectSampleLocation}
				onAddNewRow={handleAddNewRow}
				allSampleList={allSampleList}
				selectedRowId={selectedRowId}
				setSelectedRowId={setSelectedRowId}
				countryList={countryList}
				setAllSampleList={setAllSampleList}
				brands={brands}
				suppliers={suppliers}
				errors={sampleErrors}
				fetchSuppliers={fetchSuppliers}
				getBrands={getBrands}
				fetchSampleLocations={fetchSampleLocations}
				locationsList={locationsList}
				onWrongEntry={handleWrongEntry}
				parentId={parentId}
				isNetexDesign={selectedDesignInfo?.selectedNitexDesign?.value}
				designDetails={designDetails}
				onChangeSampleOwner={handleChangeSampleOwner}
			/>
			{renderBottomPart()}
			{showAddLocationModal && (
				<AddLocationModal
					onClose={handleCloseLocationModal}
					locationsList={locationsList}
					fetchSampleLocations={fetchSampleLocations}
					countryList={countryList}
					selectdLocationToEdit={selectdSampleToEdit}
					setShowAddLocationModal={setShowAddLocationModal}
					setAllSampleList={setAllSampleList}
					activeRow={activeRow}
				/>
			)}
			{isOpenAddNewFabricModal && (
				<ModalContainer
					onCloseModal={() => setIsOpenAddNewFabricModal(false)}
					className="add-location-modal"
				>
					<div className="popup-wrapper shadow-lg">
						<AddFabricInline
							productId={productId}
							materialType="MAIN_FABRIC"
							fabricData={newlyAddedFabricData}
							existingId={mainFabric?.id || null}
							onClose={() => setIsOpenAddNewFabricModal(false)}
							onSuccess={async () => {
								formatProductInfo();
								setIsOpenAddNewFabricModal(false);
							}}
							className="common-popup add-location-modal  p-3"
						/>
					</div>
				</ModalContainer>
			)}
			{(isShowIssueModal || selectedIssueToEdit || isOpenIssueModal) && (
				<CreateAndSolveIssueModal
					onClose={() => {
						setIsShowIssueModal(false);
						setSelectedIssueToEdit(null);
						dispatch(
							updateDesignViewModalInfo({
								isOpenIssueModal: false
							})
						);
					}}
					productId={productId}
					selectedIssueToEdit={selectedIssueToEdit}
					setSelectedIssueToEdit={setSelectedIssueToEdit}
					setActiveIssueIndex={setActiveIssueIndex}
				/>
			)}

			{isShowUpdateTaskModal && (
				<AddTaskModal
					onClose={() => {
						setIsShowUpdateTaskModal(false);
					}}
					productIdList={[productId]}
				/>
			)}
			{/* {isShowCreateNewTaskModal && (
				<CreateNewTask
					onClose={() => setIsShowCreateNewTaskModal(false)}
					onOpenTaskModal={() => setIsShowUpdateTaskModal(true)}
					taskInputValueFromTaskModal={taskInputValueFromTaskModal}
				/>
			)} */}
			{isCropImage && (
				<NitexImageCropper
					isEdit={isCropImage}
					onClose={handleCloseCroperModal}
					imageSrc={mainImageUrl}
					onSave={handleSaveCropedImage}
				/>
			)}
		</React.Fragment>
	);
};

export default DesignUpdate;
